import ServiceLineDetailsPage from '@/domains/service-lines/pages/ServiceLineDetailsPage';

/**
 * Dedicated customer-mode service-line page entry.
 * Keeps customer route ownership separate from account/platform pages.
 */
export default function CustomerServiceLineDetailsPage() {
  return <ServiceLineDetailsPage mode="customer" />;
}
